import { createSlice } from '@reduxjs/toolkit';

import { loadSalesClients } from './sales-clients.middleware';
import { logout } from '../auth/auth-middleware';
import { SalesClient } from 'api';

type MyClientsState = {
    list: SalesClient[];
    currentClient: SalesClient | null;
    error: string | null;
    isLoading: boolean;
    page: number;
    pageSize: number;
    totalRecords: number;
    totalPages: number;
};

const initialState: MyClientsState = {
    list: [],
    currentClient: null,
    error: null,
    isLoading: false,
    page: 1,
    pageSize: 10,
    totalRecords: 10,
    totalPages: 1,
};

export const salesClientsSlice = createSlice({
    name: 'app/sales-clients',
    initialState,
    reducers: {
        setSalesCurrentClient: (
            state,
            action: { type: string; payload: { clientID: string | null } }
        ) => {
            if (action.payload.clientID === null) {
                state.currentClient = null;
                return;
            }

            const targetClient = state.list.find(
                (client) => client.candidate_id === Number(action.payload.clientID)
            );

            if (targetClient) {
                state.currentClient = targetClient;
            } else state.currentClient = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadSalesClients.fulfilled, (state, action) => {
                state.list = action.payload.data;
                state.error = null;
                state.isLoading = false;
                const respHeaders = action.payload.headers;
                const xPagination = respHeaders['x-pagination'];
                if (xPagination) {
                    const xPaginationObj = JSON.parse(xPagination.replace(/'/g, '"'));
                    state.page = xPaginationObj.page;
                    state.pageSize = xPaginationObj.pageSize;
                    state.totalRecords = xPaginationObj.TotalRecords;
                    state.totalPages = xPaginationObj.TotalPages;
                }
            })
            .addCase(loadSalesClients.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(loadSalesClients.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(logout.fulfilled, (state) => {
                state.list = [];
                state.error = null;
                state.isLoading = false;
            });
    },
});

export const { setSalesCurrentClient } = salesClientsSlice.actions;
export default salesClientsSlice.reducer;
